module.exports = __webpack_public_path__ + "static/media/no-reminders.2ca60ed9.svg";